import { CIcon } from '~/icons/types'
export const ciParking: CIcon = {
  name: 'parking',
  type: 'light',
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M19 2.3H5C3.5 2.3 2.2 3.5 2.2 5v14c0 1.5 1.2 2.8 2.8 2.8h14c1.5 0 2.8-1.2 2.8-2.8V5c0-1.5-1.3-2.7-2.8-2.7ZM20.2 19c0 .7-.6 1.2-1.2 1.2H5c-.7 0-1.2-.6-1.2-1.2V5c0-.7.6-1.2 1.2-1.2h14c.7 0 1.2.6 1.2 1.2v14Z'
    },
    {
      d:
        'M8.9 6.402c-.4 0-.7.4-.7.7v9.9c0 .4.3.8.8.8s.8-.3.8-.8v-2.3c2.9.3 4.7-.1 5.8-1.1.8-.7 1.2-1.7 1.2-3.1 0-1.3-.4-2.3-1.2-3-1.4-1.1-3.5-1.5-6.7-1.1Zm5.7 6.1c-.8.7-2.4.9-4.8.7v-5.4c2.3-.2 3.9.1 4.8.8.5.4.7 1.1.7 1.9-.1 1-.3 1.6-.7 2Z'
    }
  ]
}
